module.exports = __webpack_public_path__ + "img/pt_seguromovil.c4624500.png";